﻿<script setup>
    //import Counter from '@/common/data/Counter.js'

    const props = defineProps({
        title: String,
        tight: Boolean,
        height: Number
    });

    const counters = ref([]);
    const count = computed(() => {
        var total = counters.value.reduce((a, c) => a + c.value.Count, 0);
        return total;
    });
    const sectionStyle = computed(() => {
        var s = {};
        if (props.height) {
            s.height = `${props.height}rem`;
        }
        return s;
    });

    function RefreshAll() {
        for (var counter of counters.value) {
            if (counter.value.Refresh) {
                counter.value.Refresh();
            }
        }
    }

    const exporter = ref(null);
    const reporter = ref(null);

    provide('pageCounters', counters);
    provide('sectionExporter', exporter);
    provide('sectionReporter', reporter);
</script>

<template>
    <div mb-2 :style="sectionStyle">
        <div class="page-section-header text-primary"
             text-white rounded-t leading-9 px-1>
            <div class="page-section-header-slot">
                <slot name="header"></slot>
            </div>
            <span font-bold>
                <span v-if="title" mr-2>
                    {{title}}
                </span>
                <span>
                    <slot name="title"></slot>
                </span>
                <q-badge color="primary" ml-2 align="middle" v-if="counters.length">{{count}}</q-badge>
                <q-badge color="info" ml-2 align="middle" @click="RefreshAll()" cursor-pointer v-if="counters.length" title="Refresh Grid">
                    <q-icon name="recycling" />
                </q-badge>
                <q-badge color="positive" ml-2 align="middle" @click="exporter()" cursor-pointer v-if="exporter" title="Export Grid">
                    <q-icon name="file_download" />
                </q-badge>
                <q-badge color="positive" ml-2 align="middle" @click="reporter()" cursor-pointer v-if="reporter" title="Print Grid">
                    <q-icon name="print" />
                </q-badge>
            </span>
        </div>
        <q-card flat square mb-4 :class="{'p-3 bordered':!tight, 'bg-transparent': tight}">
            <slot></slot>
        </q-card>
    </div>
</template>

<style lang="scss">
    .page-section-header {
        .q-btn,
        .q-separator {
            margin-left: 0.75rem;
        }

        .page-section-header-slot {
            float: right;
            margin-top: -0.25rem;

            > div {
                display: inline-block;
                margin-left: 0.5rem;
            }
        }
    }
</style>
